<h2 mat-dialog-title>
  {{'inspectionReportCompleteConfirmDialog.Confirmation' | translate}}</h2>
<div *ngIf="isLargePdf" class="container warning" fxLayout="column" fxLayoutAlign="center center">
  <p>{{ 'inspectionReportCompleteConfirmDialog.LargePdfWarning' | translate }}</p>
</div>
<div class="container" fxLayout="column" fxLayoutAlign="center center">
  <p>{{'inspectionReportCompleteConfirmDialog.MsgChangeReportStatus' | translate}}</p>
  <p>{{'inspectionReportCompleteConfirmDialog.MsgActionReserved' | translate}}</p>
</div>
<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button class="cancel-button" color="primary" mat-dialog-close>{{'inspectionReportCompleteConfirmDialog.No' | translate}}</button>
    <button mat-raised-button color="primary" [mat-dialog-close]="'yes'">{{'inspectionReportCompleteConfirmDialog.Yes' | translate}}</button>
  </mat-dialog-actions>
</div>
